import type { FunctionComponent } from 'react';
import cx from 'classnames';

import styles from './MirrorCardBoardIcon.less';

interface MirrorCardBoardIconProps {
  backgroundImage?: string;
  backgroundColor?: string;
  isPaid: boolean;
  isCompact: boolean;
}

export const MirrorCardBoardIcon: FunctionComponent<
  MirrorCardBoardIconProps
> = ({ backgroundImage, backgroundColor, isPaid, isCompact }) => {
  if (backgroundImage) {
    return (
      <img
        className={cx(
          isPaid
            ? styles.mirrorCardBoardIconImagePaid
            : styles.mirrorCardBoardIconImage,
          isCompact ? styles.compact : styles.expanded,
        )}
        src={backgroundImage}
        alt=""
      />
    );
  }
  return (
    <div
      className={cx(
        !isPaid && styles.mirrorCardBoardIconColor,
        isCompact ? styles.compact : styles.expanded,
      )}
      style={backgroundColor ? { backgroundColor } : {}}
    />
  );
};
